import React, { Component } from 'react';
import { string, bool } from 'prop-types';
import './ToolTip.scss';

class ToolTip extends Component {
  static propTypes = {
    show: bool,
    text: string
  };

  render() {
    const { show, text } = this.props;
    if (!show) {
      return null;
    }
    return <div className="ps-tooltip">{text}</div>;
  }
}

export default ToolTip;
